import { FormLabel } from '@mui/material'
import { Markdown } from '../../Markdown'

interface FieldLabelProps {
  label: string
  required?: boolean
}

export function FieldLabel({ label, required }: FieldLabelProps) {
  return (
    <FormLabel
      component="legend"
      required={required}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        // Keep the asterisk from ever wrapping to its own line
        '& .MuiFormLabel-asterisk': { whiteSpace: 'nowrap' },
      }}
    >
      <Markdown
        typographyProps={{
          sx: {
            ...(required ? { fontWeight: 'bold' } : {}),
          },
        }}
      >
        {label}
      </Markdown>
    </FormLabel>
  )
}
